import produce from 'immer';

import { SaveInternalGroupsAction } from '../../actions/internalGroups/saveInternalGroups';
import { PageStatus } from '../../typings/common';
import { EditGroupsState } from '../../typings/groupsEditState';

export const saveInternalGroups = (state: EditGroupsState, action: SaveInternalGroupsAction): EditGroupsState => {
    return produce(state, draft => {
        draft.errors = [];
        draft.pageStatus = PageStatus.SAVING;

        Object.keys(draft.groups).forEach(key => {
            draft.groups[key].errors = {};
        });
    });
};
